import { useFeatureFlags } from './FeatureFlagsContext';
import { type FlagName } from './registry';

export const useFlag = (name: FlagName): boolean => useFeatureFlags().flags[name];
